import {
  IonButton,
  IonContent,
  IonHeader,
  IonIcon,
  IonPopover,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { call, logoWhatsapp } from "ionicons/icons";
import React, { useState } from "react";
import { getValidWhatsAppPhone } from "../common/commonFunctions";
import { BhpThemeHeaderWithBack } from "../pages/BussinessHomePage";

const CallWhatsappSelPrompt: React.FC<{
  open: boolean;
  onDidDismiss: () => void;
  phone: string;
}> = (props) => {
  return (
    <IonPopover
      isOpen={props.open}
      onDidDismiss={props.onDidDismiss}
      // dismissOnSelect={true}
    >
      <BhpThemeHeaderWithBack title={props.phone} />
      <IonContent>
        <div style={{ padding: "5px" }}>
          <IonButton
            expand="block"
            color={"tertiary"}
            onClick={() => {
              props.onDidDismiss();
              window.open(`tel:${props.phone}`);
            }}
          >
            <IonIcon icon={call} slot="start" /> Call
          </IonButton>
          <IonButton
            expand="block"
            color={"primary"}
            onClick={() => {
              props.onDidDismiss();
              window.open(
                `https://wa.me/91${getValidWhatsAppPhone(props.phone)}`,
                "_system"
              );
            }}
          >
            <IonIcon icon={logoWhatsapp} slot="start" /> Whatsapp
          </IonButton>
        </div>
      </IonContent>
    </IonPopover>
  );
};

export default CallWhatsappSelPrompt;
